import ConstructorioClient from '@constructor-io/constructorio-client-javascript';
import { initUserSegments } from '../utils/userSegmentation';

const cnstrcSdk = new ConstructorioClient({
  apiKey: window.cnstrc.indexKey,
  segments: initUserSegments(),
});

function togglePlaceholder(container) {
  const heading = '.product-heading';
  const carousel = '.product-carousel';
  const placeholderHeading = '.placeholder-heading';
  const carouselPlaceholder = '.placeholder-carousel';

  const placeholderHeadings = container.querySelectorAll(placeholderHeading);
  const placeholderCarousels = container.querySelectorAll(carouselPlaceholder);
  const headings = container.querySelectorAll(heading);
  const carousels = container.querySelectorAll(carousel);
  const elementList = [...placeholderHeadings, ...placeholderCarousels, ...headings, ...carousels];
  const elementsToRemove = elementList.filter((el) => !el.classList.contains('hidden'));
  const elementsToDisplay = elementList.filter((el) => el.classList.contains('hidden'));

  elementsToRemove.forEach((element) => {
    element.classList.add('hidden');
  });

  elementsToDisplay.forEach((element) => {
    element.classList.remove('hidden');
  });
}

/**
 * Utility function to build parameters for Constructor.io API calls, with country-specific price fields and filters
 * @param {Object} params - existing parameters object to be modified
 * @param {Boolean} rec - flag indicating if the parameters are for recommendations (true) or browse (false)
 */
function constructorParamsBuilder(params = {}, rec = false) {
  // Check if country is not US, then add country-specific price fields to hidden fields and set suitable filters
  const country = window.Shopify?.country || 'US';
  const isIntl = country !== 'US';
  const priceFields = [`price${country}`, `compareAtPrice${country}`];
  params.hiddenFields = [...(params.hiddenFields || []), ...priceFields];
  isIntl && params.hiddenFields.push('inventory_quantity_international');
  if (rec) {
    params.filters = isIntl ? { variantVisibleRecsIntl: 'True' } : { variantVisibleRecs: 'True' };
  } else {
    params.filters = isIntl ? { variantVisibleBrowseIntl: 'True' } : { variantVisibleBrowse: 'True' };
  }
}

export { cnstrcSdk, togglePlaceholder, constructorParamsBuilder };
